export const emailTemplates = {
  title: "Templates",
  createTemplate: "Create Template",
  editTemplate: "Edit Template",
  deleteTemplate: "Delete Template",
  custom: "Custom",
  system: "System",
  saveTemplate: "Save Template",
  close: "Close",
  preview: "Preview",
  copyTemplate: "Copy Template",
  createNewsletterFromTemplate: "Create newsletter from template",
  templateName: "Template Name",
  category: "Category",
  descriptionHelper: "Brief description of what this template is used for",
  templatePreview: "Template Preview",
  categories: {
    newsletter: "Newsletter",
    promotional: "Promotional",
    announcement: "Announcement",
    simple: "Simple",
    workshopBooking: "Workshop Booking",
    workshopConfirmation: "Workshop Confirmation",
    workshopNotification: "Workshop Notification",
    workshopUpdate: "Workshop Update",
    workshopSequence: "Workshop Sequence"
  },
  info: {
    title: "Email Template Management",
    editButton: "Click the Edit button on any template to open the visual editor",
    builderToggle: "Use the Legacy, Unlayer, or Stripo toggle above the editor to choose a builder",
    engineTemplates: "Templates are grouped by builder — only matching templates appear in each editor's template picker",
    systemTemplates: "System templates are pre-built and can be edited (changes are saved as custom versions)",
    customTemplates: "Custom templates are user-created and can be fully edited or deleted",
    grapeJSEditor: "Legacy editor uses MJML blocks for drag-and-drop email layouts"
  },
  editorHelp: {
    title: {
      grapejs: "How to Use the Legacy Editor",
      unlayer: "How to Use the Unlayer Editor",
      stripo: "How to Use the Stripo Editor"
    },
    grapejs: {
      gettingStartedTitle: "Getting started",
      gettingStarted1: "Start with a blank canvas or click \"Templates\" to choose a Legacy starting template",
      gettingStarted2: "Select the blocks icon in the right panel, then drag components from the left panel",
      gettingStarted3: "Select the brush icon and click any element to edit text or styling",
      templatesTitle: "Working with templates",
      templates1: "Click \"Templates\" to load a Legacy template (Unlayer and Stripo templates are listed separately)",
      templates2: "Click \"Import Content\" to paste existing text",
      templates3: "Click \"Save Template\" to save your design as a custom Legacy template",
      templates4: "Use \"Undo\" and \"Redo\" to step through changes",
      responsiveTitle: "Responsive design",
      responsive1: "Use the device icons to preview desktop, tablet, and mobile layouts",
      responsive2: "Check that text and buttons remain readable on smaller screens",
      tipsTitle: "Quick tips",
      tips1: "Use MJML blocks for email-safe layouts (sections, columns, buttons)",
      tips2: "The OVERHEAR footer is added automatically from Email Settings — you can place <!-- OVERHEAR_EMAIL_FOOTER --> for explicit control",
      tips3: "Use \"Insert variable\" for personalisation tags like {{firstName}}",
      tips4: "Send a test email before using a template in campaigns"
    },
    unlayer: {
      gettingStartedTitle: "Getting started",
      gettingStarted1: "Choose Unlayer in the builder toggle, then start blank or click \"Templates\" for Unlayer-only templates",
      gettingStarted2: "Drag blocks from the left panel into the canvas",
      gettingStarted3: "Click any block to edit content, colours, and spacing in the right panel",
      templatesTitle: "Working with templates",
      templates1: "The template picker shows only Unlayer templates for this builder",
      templates2: "Saving stores both the Unlayer design and send-ready HTML",
      templates3: "Switching to Legacy or Stripo keeps your HTML but may require rebuilding the layout in that builder",
      templates4: "Use \"Save Template\" to add a custom Unlayer template to your library",
      responsiveTitle: "Preview and export",
      responsive1: "Use Unlayer's preview to check the email before sending",
      responsive2: "Toggle mobile preview to confirm the layout on small screens",
      tipsTitle: "Quick tips",
      tips1: "Merge tags (e.g. {{firstName}}) are available in text blocks via the merge-tag menu",
      tips2: "The OVERHEAR footer from Email Settings appears at the bottom while you edit",
      tips3: "Footer links update automatically when you change Email Settings",
      tips4: "Send a test email before using a template in campaigns"
    },
    stripo: {
      gettingStartedTitle: "Getting started",
      gettingStarted1: "Choose Stripo in the builder toggle, then start blank or click \"Templates\" for Stripo-only templates",
      gettingStarted2: "Use the block library on the left to add structures, text, images, and buttons",
      gettingStarted3: "Select a block in the canvas to edit styles and content in the side panel",
      templatesTitle: "Working with templates",
      templates1: "The template picker shows only Stripo templates for this builder",
      templates2: "Saving stores Stripo HTML/CSS source plus compiled send HTML",
      templates3: "Content from Unlayer or Legacy is not shown in Stripo until you rebuild the email here",
      templates4: "Use \"Save Template\" to add a custom Stripo template to your library",
      responsiveTitle: "Preview and modules",
      responsive1: "Use Stripo's preview to review the final email layout",
      responsive2: "General Styles and modules are enabled when using a native Stripo template structure",
      tipsTitle: "Quick tips",
      tips1: "The OVERHEAR footer from Email Settings is injected automatically at the bottom",
      tips2: "Footer links update automatically when you change Email Settings",
      tips3: "Switching builders exports HTML first — save before changing if you have unsaved edits",
      tips4: "Send a test email before using a template in campaigns"
    }
  },
  deleteWarning: "Warning: This is a system template. Deleting it may affect existing email campaigns and functionality.",
  deleteConfirm: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
  noTemplatesForBuilder: "No templates for this builder yet.",
  version: "Version {{version}}",
  lastUpdated: "Updated {{date}}",
  testSend: {
    title: "Send test email",
    emailLabel: "Test email address",
    helper: "A test email will be sent with sample personalisation data.",
    send: "Send test",
    success: "Test email sent to {{email}}",
    error: "Failed to send test email",
    invalidEmail: "Please enter a valid email address",
  },
}
